import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Container } from "@mui/material";
import { makeStyles } from "@mui/styles";

import Page from "src/components/Page";
import Header from "./Header";
import Results from "./Result";
import { fetchSocietyList } from "src/actions/societyAction";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: 100,
  },
}));

function Society() {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchSocietyList());
  }, [dispatch]);

  return (
    <Page
      className={classes.root}
      title="Society"
    >
      <Container maxWidth={false}>
        <Header />
        <Results />
      </Container>
    </Page>
  );
}

export default Society;